// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3LJTp","amount":"Amount_amount__guFLq","tip":"Amount_tip__8A-xt","tipHeader":"Amount_tipHeader__LCDFR","tipsWrap":"Amount_tipsWrap__bJPv_"};